import { render, staticRenderFns } from "./OfferWantBuysDetails.vue?vue&type=template&id=5b4d2d2c&scoped=true&"
import script from "./OfferWantBuysDetails.vue?vue&type=script&lang=js&"
export * from "./OfferWantBuysDetails.vue?vue&type=script&lang=js&"
import style0 from "./OfferWantBuysDetails.vue?vue&type=style&index=0&id=5b4d2d2c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4d2d2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
